// @spec AI-STR-022
// TanStack Router route for AI data quality review page

import { createFileRoute } from '@tanstack/react-router';

import { QualityReviewPage } from '@/features/ai/quality';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ai/quality')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.aiDataQualityReview'),
  }),
  component: AIQualityPage,
});

function AIQualityPage() {
  return <QualityReviewPage />;
}
